import SvgIcon, {
  SvgIconProps,
} from '@mui/material/SvgIcon';
import React from 'react';

export default function CommentsIcon(props: SvgIconProps) {
  return (
    <SvgIcon
      {...props}
      viewBox="0 0 20 20"
      fill="none"
      htmlColor="transparent"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.29824 8.93402C7.8684 8.93402 7.5192 8.58482 7.5192 8.15497C7.5192 7.7264 7.8684 7.3772 8.29824 7.3772C8.72808 7.3772 9.07729 7.7264 9.07729 8.15497C9.07729 8.58482 8.72808 8.93402 8.29824 8.93402ZM5.26943 8.93404C4.83959 8.93404 4.49039 8.58484 4.49039 8.155C4.49039 7.72642 4.83959 7.37722 5.26943 7.37722C5.69928 7.37722 6.04848 7.72642 6.04848 8.155C6.04848 8.58484 5.69928 8.93404 5.26943 8.93404ZM10.5482 8.155C10.5482 8.58484 10.8974 8.93404 11.3272 8.93404C11.757 8.93404 12.1063 8.58484 12.1063 8.155C12.1063 7.72642 11.757 7.37722 11.3272 7.37722C10.8974 7.37722 10.5482 7.72642 10.5482 8.155Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.15266 1.34009C4.27932 1.34009 1.47266 4.50417 1.47266 8.01677C1.47266 9.13845 1.79932 10.2928 2.37266 11.3478C2.47932 11.522 2.49266 11.7417 2.41932 11.9493L1.97266 13.4449C1.87266 13.8055 2.17932 14.0719 2.51932 13.965L3.86599 13.5651C4.23266 13.4449 4.51932 13.5978 4.85932 13.8055C5.83266 14.379 7.04599 14.6734 8.13932 14.6734C11.446 14.6734 14.806 12.1163 14.806 7.99674C14.806 4.44408 11.9393 1.34009 8.15266 1.34009Z"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
}
